import { inject } from '@angular/core';
import { Router } from '@angular/router';
import {
  NotificationActionContract,
  NotificationUrlActionContract,
} from '../../contracts/notification-action.contract';
import { Handler } from './handler.type';

export function createUrlNotificationActionHandler(): Handler<NotificationUrlActionContract> {
  const router = inject(Router);

  return {
    handle: (action: NotificationUrlActionContract) => handleUrl(action, router),
    support: isNotificationUrlActionContract,
  };
}

function isNotificationUrlActionContract(
  action: NotificationActionContract,
): action is NotificationUrlActionContract {
  return 'url' in action;
}

export function handleUrl(action: NotificationUrlActionContract, router: Router): Promise<void> {
  return router.navigateByUrl(action.url).then();
}
